import { ButtonReset, Box, Stack } from '@koob/margaret';
import styled from 'styled-components';

const ActiveFilterBase = styled(Stack).attrs({
  paddingHorizontal: 0.75,
  paddingVertical: 0.5,
})`
  background-color: #ffffff;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.separator};
  border-radius: 999px;
  margin: ${({ theme }) => theme.spacing(0.25)};
`;

const ActiveFiltersBase = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  margin: ${({ theme }) => theme.spacing(-0.25)};
`;

const Icon = styled(Stack)`
  font-size: 20px;
  color: ${({ theme }) => theme.textLight};
`;

const ActiveFilter = ({ onClear, children }) => (
  <ActiveFilterBase gutterSize={0.5} alignY="center">
    <span>{children}</span>
    <ButtonReset type="button" onClick={onClear}>
      <Icon>
        <i className="fa-regular fa-circle-xmark" />
      </Icon>
    </ButtonReset>
  </ActiveFilterBase>
);

const ActiveFilters = (props) => <ActiveFiltersBase {...props} />;

ActiveFilters.Filter = ActiveFilter;

export default ActiveFilters;
